module.exports = __webpack_public_path__ + "img/empty.78464357.svg";